import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IEquisBreadcrumb } from '@tn-equis/core/components/breadcrumb';
import { EquisNavigatorService } from '@tn-equis/core/services';
import { BehaviorSubject, Observable } from 'rxjs';

import { BreadcrumbService } from 'src/app/core/services/breadcrumb/breadcrumb.service';
import {
  IContactUsBreadcrumbData,
  IEquisBreadcrumbTree,
} from '../../models/breadcrumb';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
  public breadcrumbs$: Observable<
    Array<IEquisBreadcrumbTree | IContactUsBreadcrumbData>
  > = new BehaviorSubject([]);
  public isMobile: boolean = false;

  constructor(
    private readonly breadcrumbService: BreadcrumbService,
    private readonly navigatorService: EquisNavigatorService,
    private readonly router: Router,
    public readonly activatedRoute: ActivatedRoute,
  ) {}

  public ngOnInit(): void {
    this.initialize();
  }

  private initialize(): void {
    this.isMobile = this.navigatorService.isMobile;
    this.breadcrumbs$ = this.breadcrumbService.getBreadcrumb();
  }

  public breadcrumbClick(event: IEquisBreadcrumb): void {
    const { path } = this.urlParse(event.path!);

    if (!this.isExternalUrl(path)) {
      const currentBreadcrumbs = this.breadcrumbService.getCurrentBreadcrumbs();

      const clickedIndex = currentBreadcrumbs.findIndex(
        (b: IEquisBreadcrumbTree) => b.path === event.path,
      );
      let preloadedBreadcrumbs: IEquisBreadcrumbTree[] | undefined;

      if (clickedIndex !== -1) {
        preloadedBreadcrumbs = currentBreadcrumbs.slice(0, clickedIndex);
      }

      this.router.navigate([path], {
        state: {
          preloadedBreadcrumbs,
        },
      });
    } else {
      this.redirectTo(path);
    }
  }

  public redirectTo(url: string): void {
    window.location.href = url;
  }

  private urlParse(pathData: string): any {
    const [path, queryParams] = pathData.split('?');
    const queryParam = this.parseQueryParams(queryParams);
    return { path: `${path}`, queryParam };
  }

  private parseQueryParams(queryParams?: string): object {
    const queryParam: { [key: string]: string } = {};
    if (queryParams) {
      queryParams.split('&').forEach(param => {
        const [key, value] = param.split('=');
        queryParam[key] = value;
      });
    }
    return queryParam;
  }

  /**
   * Returns true if the given url looks external
   */
  private isExternalUrl(url: string): boolean {
    return /^http(?:s)?:\/{2}\S+$/.test(url);
  }
}
